<template>
  <div class="klyme-page">
    <Loader v-if="!id && !isError" />
    <klyme-widget :id="id"></klyme-widget>
    <div v-if="isError" class="klyme-page-stub">
      <img src="./images/warning.png" class="klyme-page-stub__image" />
      <h2 class="klyme-page-stub__title">Oops!</h2>
      <p class="klyme-page-stub__text">Something went wrong.</p>
      <p class="klyme-page-stub__text">Please try again or contact our support team.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from './components/Loader.vue';
export default {
  components: { Loader },
  async created() {
    await this.loadScript();
  },

  watch: {
    uuid(value) {
      if (!this.id && this.scriptLoaded && value) this.id = value;
    },
    scriptLoaded(newValue, oldValue) {
      if (!oldValue && newValue && !this.id && this.uuid) this.id = this.uuid;
    },
  },

  data() {
    return {
      scriptLoaded: false,
      id: '',
      isError: false,
    };
  },

  computed: {
    ...mapState(['paymentInvoiceData', 'flowData']),

    uuid() {
      const { requisites } = this.flowData?.payload || {};

      if (requisites && requisites.hasOwnProperty('uuid')) {
        return requisites.uuid;
      }

      return '';
    },

    testMode() {
      return this.paymentInvoiceData?.data?.test_mode || false;
    },
  },
  methods: {
    async loadScript() {
      const script = this.testMode ? KlymeTest : KlymeProd;

      if (this.hasScriptInBody(script)) {
        this.scriptLoaded = true;
        return;
      }

      const scriptTag = document.createElement('script');
      scriptTag.src = script;
      scriptTag.onload = () => {
        this.scriptLoaded = true;
      };
      scriptTag.onerror = e => {
        console.error(e);
        this.isError = true;
      };
      document.body.appendChild(scriptTag);
    },

    hasScriptInBody(link) {
      const scripts = document.querySelectorAll(`[src="${link}"]`);

      return !!scripts.length;
    },
  },
};
</script>
<style lang="scss" scoped>
.klyme-page {
  display: flex;
  justify-content: center;
  align-items: center;

  &-stub {
    &__image {
      height: 100px;
    }

    &__title {
      margin: 0 0 5px;
    }

    &__text {
      margin: 0;
    }
  }
}
</style>
